// ##### 25-02-12 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import HotelBookButton from '../../../PageComponents/HotelBookButton/HotelBookButton';
// ##### 25-02-12 Komarov
import moment from 'moment';
import { useSelector } from 'react-redux';
// ##### 25-04-29 Komarov
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-08-22
import { useMemo } from 'react';

const HotelRatesContent = ({ gridAutoRows, hotelPrice, id }) => {
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // Memoize date difference
  const date_difference = useMemo(() =>
    moment(search_data?.end).diff(moment(search_data?.start), 'days'),
    [search_data?.end, search_data?.start]
  );
  const adults = search_data?.adults;

  // ##### Komarov 2025-08-05
  const Adults = useSelector(state => state.pagesRedux[state.language]?.Adults || '');
  const TotalCost = useSelector(state => state.pagesRedux[state.language]?.TotalCost || '');
  const Days = useSelector(state => state.pagesRedux[state.language]?.Days || '');
  const Inclusions_1 = useSelector(state => state.pagesRedux[state.language]?.Inclusions_1 || '');
  const See_Availability = useSelector(state => state.pagesRedux[state.language]?.['See Availability'] || '');
  const ViewMore = useSelector(state => state.pagesRedux[state.language]?.ViewMore || '');

  // ##### 24-04-23 Komarov
  const from = useSelector(state => state.pagesRedux[state.language]?.From || '');
  // ##### 25-02-12 Komarov
  // ##### 25-04-21 Komarov: Если в hotel значение notavail установлено в 0, то выводим этот отель как доступный сейчас, иначе - как отель под запрос
  const hotel_avail = useSelector(state => state.hotels.hotels_avail.data.hotels[id].notavail);
  const isHotelAvailable = useMemo(() => !!!parseInt(hotel_avail), [hotel_avail]);
  // ##### 25-04-21 Komarov
  const hotelName = useSelector(state => state.hotels.hotels_avail.data.hotels[id].hotel_name);
  // ##### 25-02-21 Komarov
  const pickedCurrency = useSelector(state => state.currency.pickedcurrency);
  // ##### 25-04-21 Komarov
  const hotelContractCurrencyId = useSelector(state => state.hotels.hotels_avail.data.hotels[id].contr_currency_id);
  const currencies = useSelector(state => state.currency.currencies);
  const fromCurrencyRate = useMemo(() =>
    currencies.find(currency => parseInt(currency.id) === parseInt(hotelContractCurrencyId))?.value || 1,
    [currencies, hotelContractCurrencyId]
  );
  const toCurrencyRate = useMemo(() =>
    currencies.find(currency => pickedCurrency === currency.name)?.value || 1,
    [currencies, pickedCurrency]
  );
  const exchangeRate = useMemo(() => fromCurrencyRate / toCurrencyRate, [fromCurrencyRate, toCurrencyRate]);
  const totalCost = useMemo(() =>
    Math.fround(hotelPrice * adults * exchangeRate).toFixed(2),
    [hotelPrice, adults, exchangeRate]
  );

  return (
    <div
      data-component="HotelRatesContent"
      style={{
        display: 'grid',
        gridTemplateColumns: '20% 80%',
        gridAutoRows,
      }}
    >
      {process.env.NODE_ENV === 'development' && (
        <div className="hotel-id">{id}</div>
      )}
      <h3
        style={{
          gridColumn: '2',
          gridRow: '2',
          textAlign: 'end',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            color: 'grey',
            fontWeight: 'bold',
            marginBottom: '1vh',
          }}
        >
          {isHotelAvailable && TotalCost}
          <span style={{ marginLeft: '5px' }} />
          {date_difference}
          <span style={{ marginRight: '5px' }} />
          {Days}
          , {adults} <span style={{ marginRight: '5px' }} />
          {Adults}
        </div>
        {isHotelAvailable && (
          <div
            style={{
              fontSize: '14px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            {from} {pickedCurrency} {totalCost}
          </div>
        )}
      </h3>
      {isHotelAvailable && (
        <h4
          style={{
            fontSize: '14px',
            color: 'grey',
            fontWeight: 'bold',
            gridColumn: '2',
            gridRow: '3',
            textAlign: 'end',
          }}
        >
          {Inclusions_1}
        </h4>
      )}
      <div
        style={{
          gridColumn: '2',
          gridRow: '4',
          textAlign: 'end',
        }}
      >
        <HotelBookButton
          innerText={(isHotelAvailable && See_Availability) || ViewMore}
          hotelName={decodeURIComponent(hotelName)}
          id={id}
        />
      </div>

    </div>
  );
};

export default React.memo(HotelRatesContent);
